import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { storyTellerActions } from '../../actions';
import {
  ChangeStoryChatActionPayload,
  UpdateStoryActionPayload,
} from '../../typedefs';
import { PayloadActionWithPromiseMeta } from '@core/FinalForm/typedefs';
import {
  FormErrors,
  getServerFormErrors,
  ServerFormErrors,
} from '@core/FinalForm/getServerErrors';
import { call } from 'redux-saga/effects';

export function* updateStoryChat({
  payload,
  meta: { resolve, reject },
}: PayloadActionWithPromiseMeta<UpdateStoryActionPayload>) {
  try {
    yield effects.put(storyTellerActions.startFetching());
    const body: string = yield effects.call(JSON.stringify, payload);
    const response: Response = yield effects.apply(api, api.patch, [
      { endpoint: `storytellers/chats/${payload.chat_id}/`, body },
    ]);
    if (!response.ok) {
      const errors: ServerFormErrors = yield call([response, 'json']);
      const formErrors: FormErrors = yield call(getServerFormErrors, errors);
      reject(formErrors);
      yield throwError(response);
    }

    const data: ChangeStoryChatActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(storyTellerActions.changeStoryChat(data));
    resolve();
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(storyTellerActions.stopFetching());
  }
}
